// Lib
import React, { useState, forwardRef, useCallback, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { Snackbar as MuiSnackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';

import { useStyles } from './SnackbarStyles';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Snackbar = ({ severity = 'error', message, onCloseCallback }) => {
  const { classes, cx } = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message) {
      setOpen(true);
    }
  }, [message]);

  const onClose = useCallback(
    (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      onCloseCallback && onCloseCallback();
      setOpen(false);
    },
    [setOpen, onCloseCallback],
  );

  return (
    <Stack spacing={2} className={classes.stack}>
      <MuiSnackbar open={open} autoHideDuration={3000} onClose={onClose}>
        <Alert
          className={cx(classes.message, classes.alertWidth)}
          onClose={onClose}
          severity={severity}>
          {message}
        </Alert>
      </MuiSnackbar>
    </Stack>
  );
};

export default Snackbar;
